:host {
    display: block;
    position: relative;

    .bubble-cluster {
        // border: 1px solid orange; // DEBUG para ver los bordes del contenedor
        height: 100%;
        width: 100%;

        .count {
            position: absolute;
            bottom: -5px;
            left: -5px;
            font-size: var(--font-size-mi-2);
            font-weight: bold;
            color: #fff;
            border-radius: 50%;
            background: var(--color-orange);
            width: 24px;
            height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 2px solid #fff;
            // shadow
            box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
        }
    }
}